import React from 'react'
import ReactDOM from 'react-dom'
import './styles'
import { ToastContainer } from 'react-toastify'
import CookieConsent from 'react-cookie-consent'
import App from './views/app'
import 'react-confirm-alert/src/react-confirm-alert.css'
import 'react-toastify/dist/ReactToastify.css'

ReactDOM.render(
  <React.StrictMode>
    <App />
    <ToastContainer />
    <CookieConsent
      buttonText="Eu entendo"
      buttonStyle={{ color: '#fff', backgroundColor: '#e49042', fontSize: '13px' }}
    >
      Nosso site usa cookies para melhorar a experiência do usuário.{' '}
      <div>
        <small>
          Consulte nossos&nbsp;
          <a
            className="c-hand"
            href="https://petis.me/termos/"
            target="_blank"
            rel="noreferrer"
          >
            termos de uso
          </a> para saber mais
        </small>
      </div>
    </CookieConsent>
  </React.StrictMode>,
  document.getElementById('root'),
)
